<p-toast position="top-right"></p-toast>

<div class="main-feedback-container">

   

    <div class="loading-form-data-msg" *ngIf="isFormdataLoading">
        <span class="text-with-dots">
          Feedback forms are loading, please wait
          <span class="dots-loader">
            <fa-icon [icon]="faCircle" class="dot dot1"></fa-icon>
            <fa-icon [icon]="faCircle" class="dot dot2"></fa-icon>
            <fa-icon [icon]="faCircle" class="dot dot3"></fa-icon>
          </span>
        </span>
    </div>

    <div class="main-dropdowns-container" *ngIf="!isFormdataLoading">
        <div class="selection-block">
            <label>User rol:</label>
            <p-select [options]="rolesDropdown()" 
            [(ngModel)]="selectedRole" 
            optionLabel="description" 
            (onChange)="onUserRoleChange($event)"
            [disabled]="isRoleDropdownDisabled"
            ></p-select>
        </div>
        <div class="selection-block">
            <label>Feedback type:</label>
            <p-select [options]="feedbackTypeDropdown()" 
            [(ngModel)]="selectedFeedbackType" 
            optionLabel="description" 
            (onChange)="onFeedbackTypeChange($event)"></p-select>
          </div>
        <div class=""></div>

    </div>
    <div class="feedback-container" *ngIf="!isFormdataLoading">

        <div *ngIf="selectedFeedbackType.selectorId === '1'" class="form-1 form-view h-100">
            <app-initiate-trade-form></app-initiate-trade-form>
        </div>

        <div *ngIf="selectedFeedbackType.selectorId === '2'" class="form-2">
            <app-close-trade-form></app-close-trade-form>
        </div>
        <div *ngIf="selectedFeedbackType.selectorId === '3'" class="form-3">
            <app-open-close-form></app-open-close-form>
        </div>
        <div *ngIf="selectedFeedbackType.selectorId === '4'" class="form-4">
            <app-model-directions-form></app-model-directions-form>
        </div>
        <div *ngIf="selectedFeedbackType.selectorId === '5'" class="form-5">
            <app-market-events-form></app-market-events-form>
        </div>
        <div *ngIf="selectedFeedbackType.selectorId === '6'" class="form-6">
            <app-others-form></app-others-form>
        </div>


    </div>

    <div class="buttons-container feedback-buttons" *ngIf="!isFormdataLoading">
        <!-- <button class="submit-button formated-button" 
            (click)="onSubmitForm()" 
            [disabled]="isSubmitButtonDisabled()">Submit</button> -->
            <app-loading-button
            [label]="'Submit feedback'"
            [isLoading]="isSpinnerVissible()"
            [isDisabled]="isSubmitButtonDisabled()"
            (clicked)="onSubmitForm()"
            [customClass]="'feedback-run-button'"
            ></app-loading-button>
    </div>

    <app-confirmation-module [isVisible]="isConfirmationModalOpen" (close)="closeConfirmationModal()"
    (confirm)="confirmSubmit()"></app-confirmation-module>
    

</div>
